import ClientInvoiceItem from '../../../Domain/ClientInvoiceItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';
import selectHelper from '../../../Helpers/selectHelper';

class ClientInvoiceWindowDescription {
  static titleForCreate = 'Generate Invoice';
  static titleForEdit = 'Generate Invoice';
  static itemType = ClientInvoiceItem;
  static serviceFunction = (edited) => ClientInvoiceService.PostClientInvoice(edited);
  // The backend returns an empty 200 and delivers the invoice number via an in-app notification,
  // so there is no response message to interpolate (the old panel's "Invoice No:{WSresponse}" was a
  // dormant, never-substituted placeholder).
  static messageOnSuccess = 'Invoice has been created. For further processing please open this Invoice in Caspian.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'Provide the billing details for this invoice.',
      fields: [
        {
          fieldName: 'ClientName',
          label: 'Client',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.emptyValidityChecker,
          idFilter: 'CiCcid',
        },
        {
          fieldName: 'CiBtid',
          label: 'Bill To Contact ',
          className: 'col-6',
          type: InputTypesEnum.ActiveContactSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          idFilter: 'CiCcid',
        },
        {
          fieldName: 'CiVatnumber',
          label: 'Bill To Client Tax #',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'CiDefaultReportName',
          label: 'Invoice Form',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: ClientInvoiceWindowDescription.getInvoiceFormOptions(),
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'OpportunityCurrencyName',
          label: 'Currency',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.forRequiredSelectField,
          idFilter: 'CiRcyid',
        },
      ],
    },
  ];

  static getInvoiceFormOptions() {
    return selectHelper.generateSelectValues([
      '',
      'Detailed US',
      'Detailed Belgium',
      'Detailed Brazil',
      'Detailed China Mandarin',
      'Detailed China English',
      'Detailed India',
      'Detailed Singapore (multi currency)',
      'Detailed Singapore (single currency)',
      'Summary US',
      'Summary Belgium',
      'Summary Brazil',
      'Summary China Mandarin',
      'Summary China English',
      'Summary India',
    ]);
  }
}

export default ClientInvoiceWindowDescription;
